/** Факты товара как в прежней панели: `{ключ}` значение — их подставляют в промпт. */
export function FactsLine({ facts }: { facts: { fact_key: string; fact_value: string }[] }) {
  return (
    <>
      {facts.map((f, n) => (
        <span key={f.fact_key}>
          {n > 0 ? " · " : null}
          <b className="font-mono text-[11.5px] font-medium text-accent-text">{`{${f.fact_key}}`}</b> {f.fact_value}
        </span>
      ))}
    </>
  );
}
